export default __webpack_public_path__ + "static/media/CNo.80-6.37bf5c7f.jpg";